const GREETING_MESSAGE = "Hi, I'm Penny, your virtual travel assistant! How can I help you today?";
export { GREETING_MESSAGE };
